import { render } from "./SurveyPage.vue?vue&type=template&id=e03a2be4"
import script from "./SurveyPage.vue?vue&type=script&lang=js"
export * from "./SurveyPage.vue?vue&type=script&lang=js"

import "./SurveyPage.vue?vue&type=style&index=0&id=e03a2be4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__